Vue.component('autocomplete', {
	data: function () {
        return {
            results: [],
    		search: "",
            initialSearch: null,
    		isOpen: false,
    		arrowCounter: -1,
    		minLength: 3,
    		destList: [],
            destSelected: {},
    		handle: null,
            inputChangeEvent: null,
            inputBlurEvent: null,
            inputBlurBubblesEvent: null,
            inputClickEvent: null,
            sharedState: null,
            inputField: null,
            type: '',
            isFocussed: false,
            scrollRoot: null,
            destinationFieldActive: false
        };
	},
    mounted: function() {
        this.type = this.$refs.hotelAutocomplete ? 'hotelAutocomplete' : 'autocomplete';
        this.inputField = this.$refs[this.type];
        this.sharedState = win.store.state;
        this.initAutocomplete();
        this.inputChangeEvent = new Event('change', { bubbles: true });
        this.inputBlurEvent = new Event('blur', { bubbles: false });
        this.inputClickEvent = new Event('destination-click', { bubbles: true });
        this.inputBlurBubblesEvent = new Event('destination-blur', { bubbles: true });

        var findScrollRoot = $d.parents(this.inputField, '.scroll-root');
        if (findScrollRoot) this.scrollRoot = findScrollRoot;
    },
	methods: {
        initAutocomplete: function() {
            // typpe 2 = country
            if (this.type == 'autocomplete' && this.sharedState.destinationType != 2) {
                this.setInputValue((this.sharedState.destinationString || this.sharedState.query.dsti) || '');
                win.store.set('dstIdSelect', (this.sharedState.destinationIndex || this.sharedState.query.dsti) || null);
                win.store.set('dstTypeSelect', (this.sharedState.destinationType || this.sharedState.query.dstt) || null);
                win.store.set('dstStringSelect', (this.sharedState.destinationString || this.sharedState.query.dsts) || null);
            }
        },
        repositionPanel: function() {
            var pageWidth = document.body.clientWidth,
                margin = 22,
                panelWidth = 560,
                panelHeight = 361,
                $panel = this.$refs.panel,
                viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            
            $panel.style.top = (this.inputField.offsetTop + this.inputField.clientHeight) + (this.isMobile() ? 2 : 2) + 'px';
            if (panelWidth + 2 * margin > pageWidth) {
                $panel.style.marginLeft = '';
                return;
            }
            var fieldPos = this.inputField.getBoundingClientRect();
            if (fieldPos.left + panelWidth > pageWidth) {
                $panel.style.marginLeft = (pageWidth - fieldPos.left - panelWidth - 22) + 'px';
            } else if (this.sharedState.rtl && fieldPos.left + fieldPos.width < panelWidth) {
                $panel.style.marginRight = (fieldPos.left + fieldPos.width - panelWidth - 22) + 'px';
            }
        },
        getSuggestion: function(event) {
            var searchText = event.target.value;
            this.search = searchText;
			if (searchText.length >= this.minLength) {

				this.handle = win.$ajax.getJson({

	                url:  win.jsonUrl.autocomplete,
					params: { 
                        search: searchText, 
                        languageCode: this.sharedState.locale,
                        onlyHotels: this.type == 'hotelAutocomplete' ? 1 : 0 
                    },
					abort: this.handle,
	                scope: this,
	                success: function(json) {

	                    this.results = json.results;
						this.destList = this.getDestinations(json.results);

	                    this.setPanelOpen(this.results.length > 0);
	                },
	                failed: function(errorType) {
	                    this.setPanelOpen(false);
	                }
	            });
			} else {
                this.setPanelOpen(false);
            }
        },
        selectDest: function(dest) {
            this.setInputValue(dest.text);
            this.setPanelOpen(false);
            this.storeDest(dest);            
        },
        setInputValue: function(search) {
            this.search = search;
            this.inputField.value = search;
        },
        cancelInput: function() {
            this.setInputValue("");
            this.setPanelOpen(false);
            this.inputField.focus();
        },
        setPanelOpen: function(isOpen) {
            if (this.isOpen == isOpen) return;
            document.body.classList[isOpen ? 'add': 'remove']('autocomplete-visible');
            this.isOpen = isOpen;
            if (isOpen) {
                if (this.isMobile()) {
                    win.$d.scrollto({ distance: -2, toElement: this.inputField, duration: 0, root: this.scrollRoot });
                }
                this.repositionPanel();
                this.$nextTick(function() {
                    if (this.$refs.panel.scrollTo) this.$refs.panel.scrollTo(0,0);
                });
            }
        },
		onArrowDown: function() {
	  		if (this.arrowCounter < this.destList.length -1 ) {
				this.arrowCounter = this.arrowCounter + 1;
	  		}
		},
		onArrowUp: function() {
	  		if (this.arrowCounter > 0) {
				this.arrowCounter = this.arrowCounter - 1;
	  		}
		},
		onEnter: function() {
            this.setPanelOpen(false);
            if (this.arrowCounter != -1) {
                this.setInputValue(this.destList[this.arrowCounter].text);
                this.storeDest(this.destList[this.arrowCounter]);
            } else if (this.destList.length > 0) {
                this.setInputValue(this.destList[0].text);
                this.storeDest(this.destList[0]);
            }
            this.triggerChange();
            this.arrowCounter = -1;
		},
		onMouse: function() {
			this.arrowCounter = -1;
		},
		getDestinations: function(results) {
			var destList = [];
			destList[-1] = { mixDestId:"-1" };
			results.forEach(function(type) {
				type.strInHTML.forEach(function(dest) {
				   dest.intDestType = type.intDestType;
	               destList.push(dest);
	            });
            });
			return destList;
		},
		storeDest: function(dest) {
            this.destSelected = dest;
            win.store.set('dstTypeSelect', dest.intDestType);
            win.store.set('dstIdSelect', dest.mixDestId);
            win.store.set('dstStringSelect', dest.text); // take directly from search field?
            if (this.type == 'hotelAutocomplete' && dest.intDestType == 8) {
                this.submitHotelSearch(dest);
            } else {
                this.triggerChange();
            }
		},
        triggerChange: function() {
            if (this.search != this.initialSearch) {
                this.maybeClearDestination();
                this.inputField.dispatchEvent(this.inputChangeEvent);
            }            
        },
        closePanel: function(event) {
            if (!this.isOpen) return;
            if (event) event.stopPropagation();
            this.setPanelOpen(false);
            this.arrowCounter = -1;
            this.inputField.dispatchEvent(this.inputBlurEvent);
            this.showCancel = false;
            this.triggerChange();
        },

		clickInput: function(event) {
            event.stopPropagation();
            this.initialSearch = this.search;
            this.showCancel = true;
            this.inputField.dispatchEvent(this.inputClickEvent);
            this.destinationFieldActive = true;
		},
        maybeClearDestination: function() {
            if (this.search !== this.destSelected.text) {
                win.store.set('dstTypeSelect', null);
                win.store.set('dstIdSelect', null);
                win.store.set('dstStringSelect', this.search);
            }
        },
        changeInput: function(event) {
            if (!event.isTrusted) return;
            if (this.isOpen) {
                event.stopPropagation();
            } else {
                this.maybeClearDestination();
            }
        },
        blurInput: function() {
            if (document.activeElement != this.$refs.autocomplete) {
                this.inputField.dispatchEvent(this.inputBlurBubblesEvent);
                this.destinationFieldActive = false;
            }
        },
        isMobile: function() {
            return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768;
        },
        submitHotelSearch: function(dest) {
            location.href = $url.encodeVar({q : $url.encodeQ(this.sharedState.query)}, 
                {url: this.sharedState.dstIdSelect ? dest.strUrl : win.internalUrl.hotelSearch });
        }
    },
});
